export default {
  tag1: {
    title: `储能项目全链路供应链`,
    text: `上游电芯｜中游 PCS/BMS 自主研发｜储能舱｜工商业、电网储能一站式配套服务`,
  },
  tag2: {
    title: `动力电池全链路供应链`,
    text: `电芯 / 模组 / 电池包配套｜储能电池一体化供货｜储能电站整站配套交付`,
  },
  tag3: {
    title: `储能 + 充电双闭环供应链`,
    text: `储能充电一体化配套｜规模化产能降本｜全球仓储物流｜批量项目稳定交付`,
  },
  centerDataImg: require('@/assets/images/cc/tk.gif'),
  centerDataImg2: require('@/assets/images/cc/ty_cn.gif'),
};
